import { COMPANY_REFERENCE_MATERIALS_NAMES } from './routerMapConfig'

export const ROUTER_NAMES = {
	USER: {
		PROFILE: 'UserProfilePage',
	},
	COMPANY_SETTINGS: {
		USER_ACTIVITY: 'CompanyProfileUserActivityPage',
	},
	FIELDS: {
		CARD: 'CompanyCardFieldPage',
		TABLE: 'CompanyGroupLandBankModuleFieldsTablePage',
		MAP: 'CompanyGroupLandBankModuleFieldsMapPage',
		CARD_TABS: {
			GENERAL: 'CompanyCardFieldGeneralPage',
			DOCUMENTS: 'CompanyCardFieldDocumentsPage',
			FINANCE: 'CompanyCardFieldFinancePage',
			CROP_ROTATIONS: 'CompanyCardFieldCropRotationsPage',
			CROP_CONDITIONS: 'CompanyCardFieldCropConditionsPage',
			METEO: 'CompanyCardFieldMeteoPage',
			WORKS: 'CompanyCardFieldWorksPage',
			YIELD: 'CompanyCardFieldYieldPage',
			AGROCHEM: 'CompanyCardFieldAgrochemPage',
		},
	},
	CROPS_STRUCTURES: {
		DASHBOARD: 'CompanyGroupCropProductionModuleCropsStructureDashboardPage',
		LIST: 'CompanyGroupCropProductionModuleCropsStructureTablePage',
		CARD: 'CompanyCardCropBusinessProcessPage',
	},
	PROJECTS: {
		DASHBOARD: 'CompanyGroupProjectsModuleProcessesDashboardPage',
		LIST: 'CompanyGroupProjectsModuleProcessesTablePage',
	},
	LAND_BANK: {
		LAND_ACTIONS: {
			TABLE: COMPANY_REFERENCE_MATERIALS_NAMES.LAND_BANK__LAND_ACTIONS,
		},
		LAND_PURPOSES: {
			TABLE: COMPANY_REFERENCE_MATERIALS_NAMES.LAND_BANK__LAND_PURPOSES,
		},
		LAND_OWNERSHIP_TYPES: {
			TABLE: COMPANY_REFERENCE_MATERIALS_NAMES.LAND_BANK__LAND_OWNERSHIP_TYPES,
		},
		LAND_CATEGORIES: {
			TABLE: COMPANY_REFERENCE_MATERIALS_NAMES.LAND_BANK__LAND_CATEGORIES,
		},
		LANDS: {
			TABLE: 'CompanyGroupLandBankModuleLandTablePage',
			MAP: 'CompanyGroupLandBankModuleLandMapPage',
		},
		LAND_DOCUMENTS: {
			TABLE: 'CompanyGroupLandBankModuleDocumentsTablePage',
		},
		LANDS_DOCUMENT_TYPES: {
			TABLE: COMPANY_REFERENCE_MATERIALS_NAMES.LAND_BANK__LAND_DOCUMENT_TYPES,
		},
	},
	MACHINES: {
		CARD: 'CompanyCardTechnicPage',
		CARD_TABS: {
			GENERAL: 'CompanyCardTechnicGeneralPage',
			DEVICES_AND_SENSORS: 'CompanyCardTechnicDevicesAndSensorsPage',
			EVENTS: 'CompanyCardTechnicEventsPage',
			ORDERS_AND_WORK: 'CompanyCardTechnicOrdersAndWorkPage',
			INCIDENTS: 'CompanyCardTechnicIncidentsPage',
			RESOURCES: 'CompanyCardTechnicResourcesPage',
			SERVICE_BOOK: 'CompanyCardTechnicServiceBookPage',
			DOCUMENTS: 'CompanyCardTechnicDocumentsPage',
		},
		TABLE: 'CompanyGroupTechniqueAndEquipmentModuleTechniqueTablePage',
		MOVEMENTS_TABLE: 'CompanyGroupGpsMonitoringModuleMovementsTablePage',
		MOVEMENTS_MAP: 'CompanyGroupGpsMonitoringModuleMovementsMapPage',
	},
	STAFF: {
		CARD: 'CompanyCardStaffPage',
		CARD_TABS: {
			GENERAL: 'CompanyCardStaffGeneralPage',
			TASKS_AND_JOBS: 'CompanyCardStaffTasksJobsTabView',
			SALARY: 'CompanyCardStaffSalaryTabView',
			RESOURCES: 'CompanyCardStaffResourcesTabView',
			INCIDENTS: 'CompanyCardStaffIncidentsTabView',
			DRIVER_PROFILE: 'CompanyCardStaffDriverProfileTabView',
		},
		LIST: 'CompanyReferenceMaterialsStaffPage',
	},
	FIELD_DONE_WORKS_IN_PROGRESS: {
		MAP: 'CompanyGroupWorksInFieldModuleInWorkMapPage',
		TABLE: 'CompanyGroupWorksInFieldModuleInWorkTablePage',
	},
	DYNAMICS_DONE_WORKS: {
		LIST: 'CompanyGroupAllWorksModuleDynamicsTablePage',
	},
	FIELD_WORK_ORDERS: {
		GENERATOR_LIST: 'CompanyGroupWorksInFieldModuleOperationalPlanTablePage',
		GENERATOR: 'CompanyGeneratorWorkOrdersPage',
		GENERATOR_TABS: {
			FIELDS_AND_EXECUTORS: 'CompanyGeneratorWorkOrdersFieldsAndExecutorsPage',
			PARAMS: 'CompanyGeneratorWorkOrdersParamsPage',
			RESULTS: 'CompanyGeneratorWorkOrdersResultsPage',
		},
	},
	LOGISTICS: {
		TRANSPORTATION_REQUESTS: {
			TABLE: 'CompanyGroupLogisticsModuleTransportationRequestsTablePage',
		},
		WAYBILLS: {
			TABLE: 'CompanyGroupLogisticsModuleWaybillsTablePage',
			MAP: 'CompanyGroupLogisticsModuleWaybillsMapPage',
		},
		TRIP_PLANNER: {
			TABLE: 'CompanyGroupLogisticsModuleTripPlannerTablePage',
		},
		CARGO_TRANSPORTED: {
			TABLE: 'CompanyGroupLogisticsModuleCargoTransportedTablePage',
		},
		CARGO_TAGS: {
			TABLE: COMPANY_REFERENCE_MATERIALS_NAMES.RESOURCES__CARGO_TAGS,
		},
	},
	LOGISTIC_WORK_ORDERS: {
		TABLE: 'CompanyGroupLogisticsModuleWaybillsRequestsPage',
	},
	LOGISTIC_ROUTES: {
		CONSTRUCTOR: 'CompanyConstructorLogisticRoutesPage',
		TABLE: 'CompanyGroupTransportationModuleRoutesTablePage',
	},
	EVENTS: {
		TABLE: 'CompanyGroupControlModuleEventsTablePage',
	},
	DONE_WORKS_ALL_FIELD_WORKS: {
		ANALYTICS: 'CompanyModuleAllFieldWorksAnalyticsPage',
		TABLE: 'CompanyGroupWorksInFieldModuleAllFieldWorksTablePage',
		MAP: 'CompanyGroupWorksInFieldModuleInWorkMapPage',
	},
	ACTIVE_PLAN_WORKS: {
		TABLE: 'CompanyGroupWorksInFieldModuleScheduledTablePage',
	},
	REGULATIONS: {
		CARD: 'CompanyCardRegulationPage',
	},
}

export const REDIRECT_PARAMS_PAGES = {
	user_profile: ROUTER_NAMES.USER.PROFILE,
}

export const REDIRECT_PARAMS_COMPANY_PAGES = {}

export const REDIRECT_PARAMS_COMPANY_OBJECT_TYPES = {
	FIELD: 'field',
	MACHINE: 'machine',
	EVENT: 'event',
	FIELD_DONE_WORK_IN_PROGRESS: 'field_done_work_in_progress',
	FIELD_DONE_WORK_DONE: 'field_done_work_done',
	LOGISTIC_ROUTE: 'logistic_route',
	DONE_WORKS_ALL_FIELD_WORKS: 'done_works_all_field_works',
}

export const PAGES_FOR_ROUTING_PARAMS = {
	MACHINE_CARD: 'machine_card',
	MACHINES_TABLE: 'machines_table',
	MOVEMENTS_TABLE: 'movements_table',
	MOVEMENTS_MAP: 'movements_map',
	MACHINE_DISPATCHER: 'machine_dispatcher',

	FIELDS_TABLE: 'fields_table',
	FIELDS_MAP: 'fields_map',
	FIELD_CARD: 'field_card',

	LANDS_TABLE: 'lands_table',
	LAND_DOCUMENTS_TABLE: 'lands_document_types_table',

	EVENTS_TABLE: 'events_table',

	FIELD_DONE_WORKS_IN_PROGRESS_TABLE: 'field_done_works_in_progress_table',
	FIELD_DONE_WORKS_IN_PROGRESS_MAP: 'field_done_works_in_progress_map',

	FIELD_DONE_WORKS_DONE_TABLE: 'field_done_works_done_table',

	WAYBILLS_TABLE: 'waybills_table',
	WAYBILLS_MAP: 'waybills_map',

	LOGISTIC_ROUTES_CONSTRUCTOR: 'logistic-routes_constructor',
	CARGO_TRANSPORTED_TABLE: 'cargo_transported_table',

	DONE_WORKS_ALL_FIELD_WORKS_TABLE: 'done_works_all_field_works_table',
	DONE_WORKS_ALL_FIELD_WORKS_MAP: 'done_works_all_field_works_map',
	ACTIVE_PLAN_WORKS_TABLE: 'active_plan_works_table',
}

export const REDIRECT_PARAMS_COMPANY_PAGES_TO_OBJECT_TYPE = {
	[PAGES_FOR_ROUTING_PARAMS.MACHINE_CARD]: REDIRECT_PARAMS_COMPANY_OBJECT_TYPES.MACHINE,
	[PAGES_FOR_ROUTING_PARAMS.MACHINES_TABLE]: REDIRECT_PARAMS_COMPANY_OBJECT_TYPES.MACHINE,
	[PAGES_FOR_ROUTING_PARAMS.MOVEMENTS_TABLE]: REDIRECT_PARAMS_COMPANY_OBJECT_TYPES.MACHINE,
	[PAGES_FOR_ROUTING_PARAMS.MOVEMENTS_MAP]: REDIRECT_PARAMS_COMPANY_OBJECT_TYPES.MACHINE,
	[PAGES_FOR_ROUTING_PARAMS.MACHINE_DISPATCHER]: REDIRECT_PARAMS_COMPANY_OBJECT_TYPES.MACHINE,

	[PAGES_FOR_ROUTING_PARAMS.FIELDS_TABLE]: REDIRECT_PARAMS_COMPANY_OBJECT_TYPES.FIELD,
	[PAGES_FOR_ROUTING_PARAMS.FIELDS_MAP]: REDIRECT_PARAMS_COMPANY_OBJECT_TYPES.FIELD,
	[PAGES_FOR_ROUTING_PARAMS.FIELD_CARD]: REDIRECT_PARAMS_COMPANY_OBJECT_TYPES.FIELD,

	[PAGES_FOR_ROUTING_PARAMS.EVENTS_TABLE]: REDIRECT_PARAMS_COMPANY_OBJECT_TYPES.EVENT,

	[PAGES_FOR_ROUTING_PARAMS.FIELD_DONE_WORKS_IN_PROGRESS_TABLE]:
		REDIRECT_PARAMS_COMPANY_OBJECT_TYPES.FIELD_DONE_WORK_IN_PROGRESS,
	[PAGES_FOR_ROUTING_PARAMS.FIELD_DONE_WORKS_IN_PROGRESS_MAP]:
		REDIRECT_PARAMS_COMPANY_OBJECT_TYPES.FIELD_DONE_WORK_IN_PROGRESS,

	[PAGES_FOR_ROUTING_PARAMS.FIELD_DONE_WORKS_DONE_TABLE]: REDIRECT_PARAMS_COMPANY_OBJECT_TYPES.FIELD_DONE_WORK_DONE,

	[PAGES_FOR_ROUTING_PARAMS.LOGISTIC_ROUTES_CONSTRUCTOR]: REDIRECT_PARAMS_COMPANY_OBJECT_TYPES.LOGISTIC_ROUTE,

	[PAGES_FOR_ROUTING_PARAMS.DONE_WORKS_ALL_FIELD_WORKS_TABLE]:
		REDIRECT_PARAMS_COMPANY_OBJECT_TYPES.DONE_WORKS_ALL_FIELD_WORKS,
	[PAGES_FOR_ROUTING_PARAMS.DONE_WORKS_ALL_FIELD_WORKS_MAP]:
		REDIRECT_PARAMS_COMPANY_OBJECT_TYPES.DONE_WORKS_ALL_FIELD_WORKS,
}
